import { render } from "./Factors.vue?vue&type=template&id=1e6787bd&scoped=true"
import script from "./Factors.vue?vue&type=script&lang=js"
export * from "./Factors.vue?vue&type=script&lang=js"

import "./Factors.vue?vue&type=style&index=0&id=1e6787bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6787bd"]])

export default __exports__